import {
    GET_QUERY_CATEGORY_RESPONSE, GET_QUERY_CATEGORY_FAILED, GET_QUERY_SUB_CATEGORY_RESPONSE,
    GET_QUERY_SUB_CATEGORY_FAILED,
    RAISE_QUERY_CLIENT_MF_FAILED, RAISE_QUERY_CLIENT_MF_RESPONSE, RAISE_QUERY_CLIENT_PMS_RESPONSE,
    RAISE_QUERY_CLIENT_PMS_FAILED, RAISE_QUERY_RESPONSE, RAISE_QUERY_FAILED, RAISE_QUERY_CLIENT_AIF_RESPONSE, RAISE_QUERY_CLIENT_AIF_FAILED,
    CLIENT_AIF_RESPONSE, CLIENT_AIF_FAILED, CLIENT_MF_RESPONSE, CLIENT_MF_FAILED, GET_RAISE_QUERY
} from '../types/raiseQuery';

const initialState = {
    getQueryCategory: [],
    getQuerySubCategory: [],
    raiseQueryClientMF: {},
    raiseQueryClientPMS: {},
    raiseQueryClientAIF: {},
    raiseQuery: {},
    clientMF: {},
    getRaiseQuery: {}
    // clientAIF: {},
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GET_QUERY_CATEGORY_RESPONSE:
            return { ...state, getQueryCategory: action.payload }
        case GET_QUERY_CATEGORY_FAILED:
            return { ...state, getQueryCategory: action.payload }
        case GET_QUERY_SUB_CATEGORY_RESPONSE:
            return { ...state, getQuerySubCategory: action.payload }
        case GET_QUERY_SUB_CATEGORY_FAILED:
            return { ...state, getQuerySubCategory: action.payload }
        case RAISE_QUERY_CLIENT_MF_RESPONSE:
            return { ...state, raiseQueryClientMF: action.payload }
        case RAISE_QUERY_CLIENT_MF_FAILED:
            return { ...state, raiseQueryClientMF: action.payload }
        case RAISE_QUERY_CLIENT_PMS_RESPONSE:
            return { ...state, raiseQueryClientPMS: action.payload }
        case RAISE_QUERY_CLIENT_PMS_FAILED:
            return { ...state, raiseQueryClientPMS: action.payload }
        case RAISE_QUERY_RESPONSE:
            return { ...state, raiseQuery: action.payload }
        case RAISE_QUERY_FAILED:
            return { ...state, raiseQuery: action.payload }
        case RAISE_QUERY_CLIENT_AIF_RESPONSE:
            return { ...state, raiseQueryClientAIF: action.payload }
        case RAISE_QUERY_CLIENT_AIF_FAILED:
            return { ...state, raiseQueryClient: action.payload }
        case CLIENT_AIF_RESPONSE:
            return { ...state, raiseQueryClientAIF: action.payload }
        case CLIENT_AIF_FAILED:
            return { ...state, raiseQueryClientAIF: action.payload }
        case CLIENT_MF_RESPONSE:
            return { ...state, clientMF: action.payload }
        case CLIENT_MF_FAILED:
            return { ...state, clientMF: action.payload }
        case GET_RAISE_QUERY:
            return { ...state, getRaiseQuery: action.payload }

        default:
            return state
    }

}
